import { CreateAgencyMutationProvider } from "__legacy/queries/agencies/CreateAgencyMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AgencyForm, onError, onFinish } from "./AgencyForm";

export const New: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <CreateAgencyMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
      {(loading, mutate) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title={`New agency`}
            extra={
              <Fragment>
                <Button onClick={() => navigate("../")}>Back to list</Button>
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                  Save
                </Button>
              </Fragment>
            }
          />
          <Layout.Content className="content">
            <AgencyForm action="create" form={form} handler={onFinish(mutate, {}, {})} values={{}} errors={errors} />
          </Layout.Content>
        </Fragment>
      )}
    </CreateAgencyMutationProvider>
  );
};
